/* =========================================================
   1. STICKY HEADER & MAIN MEGA MENU CONTROLLER
========================================================= */
const initHeaderNavigation = () => {
  const header = document.querySelector(".login-header");
  const megaMenu = document.querySelector(".login-mega-menu");
  const menuItems = document.querySelectorAll(".login-menu__item[data-mega]");
  const panels = document.querySelectorAll(".mega-panel");

  if (!header) return;

  // Sticky Scroll Handling
  window.addEventListener("scroll", () => {
    header.classList.toggle("is-sticky", window.scrollY > 80);
  });

  if (!megaMenu) return;

  let hideTimer;

  // Function: Panel open hone par us ke pehle Category/Tab ko auto-select karna
  const activateFirstTabInPanel = (panel) => {
    if (!panel) return;

    const firstCategory = panel.querySelector(".mega-category-list li");
    if (!firstCategory) return;

    const activeTab = firstCategory.dataset.tab;

    // Reset & Activate Category
    panel.querySelectorAll(".mega-category-list li").forEach((li) => {
      li.classList.toggle("active", li === firstCategory);
    });

    // Reset & Activate Products Panel
    panel.querySelectorAll(".mega-products-panel").forEach((prod) => {
      prod.classList.toggle("active", prod.dataset.tab === activeTab);
    });

    // Reset & Activate Banners Panel
    panel.querySelectorAll(".mega-banner-panel").forEach((banner) => {
      const isActive = banner.dataset.tab === activeTab;
      banner.classList.toggle("active", isActive);

      /* =========================================================
         SWIPER SLIDER TRIGGER COMMENTED OUT (GRID LAYOUT SWITCH)
      =========================================================
      if (isActive) {
        const slider = banner.querySelector(".mega-banner-slider");
        if (slider?.swiperInstance) {
          setTimeout(() => {
            slider.swiperInstance.update();
            slider.swiperInstance.slideToLoop(0, 0);
            slider.swiperInstance.autoplay?.start();
          }, 50);
        }
      }
      ========================================================= */
    });
  };

  // Header Nav Links Hover Event
  menuItems.forEach((item) => {
    item.addEventListener("mouseenter", () => {
      clearTimeout(hideTimer);
      megaMenu.classList.add("active");

      const target = item.dataset.mega;

      panels.forEach((panel) => {
        const isTarget = panel.dataset.mega === target;
        panel.classList.toggle("active", isTarget);

        if (isTarget) {
          activateFirstTabInPanel(panel);
        }
      });
    });
  });

  megaMenu.addEventListener("mouseenter", () => clearTimeout(hideTimer));

  header.addEventListener("mouseleave", () => {
    hideTimer = setTimeout(() => {
      megaMenu.classList.remove("active");
    }, 150);
  });
};

/* =========================================================
   2. CATEGORY TABS HOVER & SWIPER INITIALIZATION
========================================================= */
const initMegaMenuTabsAndSliders = () => {
  const megaMenu = document.querySelector(".login-mega-menu");
  if (!megaMenu) return;

  /* =========================================================
     SWIPER INSTANCES INIT COMMENTED OUT (NOW USING CSS GRID)
  =========================================================
  const sliders = megaMenu.querySelectorAll(".mega-banner-slider");
  sliders.forEach((slider) => {
    const slideCount = slider.querySelectorAll(".swiper-slide").length;

    const swiper = new Swiper(slider, {
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 30,
      speed: 600,
      initialSlide: 0,
      loop: slideCount > 1,
      autoplay: slideCount > 1 ? {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      } : false,
      pagination: {
        el: slider.querySelector(".swiper-pagination"),
        clickable: true,
        dynamicBullets: false,
      },
      observer: true,
      observeParents: true,
      resizeObserver: true,
      watchOverflow: true,
      updateOnWindowResize: true,
      breakpoints: {
        0: { slidesPerView: 1, slidesPerGroup: 1, spaceBetween: 10 },
        768: { slidesPerView: 2, slidesPerGroup: 2, spaceBetween: 20 },
        992: { slidesPerView: 2, slidesPerGroup: 2, spaceBetween: 10 },
      },
      on: {
        init(instance) {
          setTimeout(() => {
            instance.update();
            instance.slideToLoop(0, 0);
            instance.autoplay?.start();
          }, 100);
        },
      },
    });

    slider.swiperInstance = swiper;
  });
  ========================================================= */

  // Category List Items Hover Event (Scoped to current panel)
  megaMenu.querySelectorAll(".mega-category-list li").forEach((item) => {
    item.addEventListener("mouseenter", () => {
      const currentPanel = item.closest(".mega-panel");
      if (!currentPanel) return;

      const tab = item.dataset.tab;

      // Update Category List
      currentPanel.querySelectorAll(".mega-category-list li").forEach((i) => {
        i.classList.toggle("active", i === item);
      });

      // Update Product Panels
      currentPanel.querySelectorAll(".mega-products-panel").forEach((prod) => {
        prod.classList.toggle("active", prod.dataset.tab === tab);
      });

      // Update Banner Panels
      currentPanel.querySelectorAll(".mega-banner-panel").forEach((banner) => {
        const isActive = banner.dataset.tab === tab;
        banner.classList.toggle("active", isActive);

        /* =========================================================
           SWIPER RE-UPDATE ON HOVER COMMENTED OUT
        =========================================================
        if (isActive) {
          const slider = banner.querySelector(".mega-banner-slider");
          if (slider?.swiperInstance) {
            setTimeout(() => {
              const instance = slider.swiperInstance;
              instance.update();
              instance.updateSize();
              instance.updateSlides();
              instance.updateProgress();
              instance.pagination?.render();
              instance.pagination?.update();
              instance.slideToLoop(0, 0);
              instance.autoplay?.start();
            }, 50);
          }
        }
        ========================================================= */
      });
    });
  });
};

/* =========================================================
   3. MOBILE MENU & ACCORDIONS (EVENT BUBBLING FIX)
========================================================= */
const initMobileNavigation = () => {
  const burger = document.querySelector(".login-header__burger");
  const mobileMenu = document.querySelector(".login-mobile-menu");
  const overlay = document.querySelector(".login-mobile-menu__overlay");

  if (burger && mobileMenu) {
    burger.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation(); // Event ko further propagation se rokta hai
      
      const isActive = mobileMenu.classList.contains("active");
      if (isActive) {
        mobileMenu.classList.remove("active");
        burger.classList.remove("active");
        document.body.classList.remove("no-scroll");
      } else {
        mobileMenu.classList.add("active");
        burger.classList.add("active");
        document.body.classList.add("no-scroll");
      }
    });

    overlay?.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      mobileMenu.classList.remove("active");
      burger.classList.remove("active");
      document.body.classList.remove("no-scroll");
    });
  }

  // Close Button Handler
  document.addEventListener("click", (e) => {
    if (e.target.closest(".login-mobile-menu__close")) {
      e.preventDefault();
      if (mobileMenu) {
        mobileMenu.classList.remove("active");
        burger?.classList.remove("active");
        document.body.classList.remove("no-scroll");
      }
    }
  });

  // Main Category Accordion
  const mainAccordionBtn = document.querySelector(".mobile-main-accordion-btn");
  if (mainAccordionBtn) {
    mainAccordionBtn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      const mainAccordion = this.closest(".mobile-main-accordion");
      if (mainAccordion) {
        mainAccordion.classList.toggle("active");
      }
    });
  }

  // Inner Accordion Items
  const categoryItems = document.querySelectorAll(".mobile-accordion-item");
  categoryItems.forEach((item) => {
    const btn = item.querySelector(".mobile-accordion-btn");
    if (!btn) return;

    btn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      const isCurrentActive = item.classList.contains("active");

      categoryItems.forEach((other) => {
        if (other !== item) {
          other.classList.remove("active");
        }
      });

      item.classList.toggle("active", !isCurrentActive);
    });
  });
};

/* =========================================================
   4. PAGE BANNER BRIGHTNESS DETECTION
========================================================= */
const initBannerBrightnessCheck = () => {
  const header = document.querySelector(".login-header");
  if (!header) return;

  const bannerSelector = [
    ".collection-banner-img",
    ".landing-banner-image",
    ".login-contact-hero img",
    ".login-privacy-policy__hero",
    ".login-blog-page__hero img",
    ".bulk-hero img",
    ".login-warranty-claim__hero img",
    ".warranty-hero img",
    ".login-about__hero img",
    ".login-policy__hero img",
    ".login-shipping__hero img",
    ".lsb-hero-banner img",
    ".login-store-locator-hero img",
    ".hero-banner-wrapper img",
    ".ds-hero-banner-wrapper img",
  ].join(", ");

  const banner = document.querySelector(bannerSelector);
  if (!banner) return;

  banner.crossOrigin = "anonymous";

  const setHeaderMode = (isDarkBanner) => {
    header.classList.toggle("login-header--banner-dark", isDarkBanner);
    header.classList.toggle("login-header--inner", !isDarkBanner);

    // Inline style force karne wali line yahan se hata di gayi hai 
    // taake CSS classes ke zariye burger color properly switch ho sake.
  };

  const detectBrightness = () => {
    if (!banner.naturalWidth || !banner.naturalHeight) return;

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    const sampleHeight = Math.min(120, banner.naturalHeight);
    canvas.width = banner.naturalWidth;
    canvas.height = sampleHeight;

    try {
      ctx.drawImage(banner, 0, 0, banner.naturalWidth, sampleHeight, 0, 0, canvas.width, canvas.height);
      const data = ctx.getImageData(0, 0, canvas.width, canvas.height).data;

      let totalBrightness = 0;
      let pixelCount = 0;

      for (let i = 0; i < data.length; i += 4) {
        totalBrightness += data[i] * 0.299 + data[i + 1] * 0.587 + data[i + 2] * 0.114;
        pixelCount++;
      }

      const averageBrightness = totalBrightness / pixelCount;
      setHeaderMode(averageBrightness < 140);
    } catch (error) {
      console.error("Banner brightness detection failed:", error);
    }
  };

  if (banner.complete && banner.naturalWidth > 0) {
    detectBrightness();
  } else {
    banner.addEventListener("load", detectBrightness, { once: true });
  }
};

/* =========================================================
   INITIALIZE ALL FUNCTIONS ON DOM LOAD
========================================================= */
document.addEventListener("DOMContentLoaded", () => {
  initHeaderNavigation();
  initMegaMenuTabsAndSliders();
  initMobileNavigation();
  initBannerBrightnessCheck();
});